var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 18C18 19.2632 17.2632 20 16 20H8C6.73684 20 6 19.2632 6 18V7H18V18ZM20 18V5H4V18C4 20.2456 5.75439 22 8 22H16C18.2456 22 20 20.2456 20 18ZM3 7H5C5.54386 7 6 6.54386 6 6C6 5.45614 5.54386 5 5 5H3C2.45614 5 2 5.45614 2 6C2 6.54386 2.45614 7 3 7ZM21 5H19C18.4561 5 18 5.45614 18 6C18 6.54386 18.4561 7 19 7H21C21.5439 7 22 6.54386 22 6C22 5.45614 21.5439 5 21 5ZM15 2H9C8.45614 2 8 2.45614 8 3C8 3.54386 8.45614 4 9 4H15C15.5439 4 16 3.54386 16 3C16 2.45614 15.5439 2 15 2ZM11 17V10C11 9.45614 10.5439 9 10 9C9.45614 9 9 9.45614 9 10V17C9 17.5439 9.45614 18 10 18C10.5439 18 11 17.5439 11 17ZM15 17V10C15 9.45614 14.5439 9 14 9C13.4561 9 13 9.45614 13 10V17C13 17.5439 13.4561 18 14 18C14.5439 18 15 17.5439 15 17Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteOutlined);
export default __webpack_public_path__ + "static/media/delete_outlined.0a01e005.svg";
export { ForwardRef as ReactComponent };